module.exports = __webpack_public_path__ + "static/media/ecomm.f8ef7743.png";